import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Button from "components/Button";
import { Field } from "react-final-form";
import TextInput from "fields/TextInput";
import useCustomerClient from "hooks/use-customer-client";
import { BASE_API_URL } from "lib/constants";

const Wrapper = styled.div`
  display: flex;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  padding: 1rem 0;
  position: relative;
  width: 100%;
`;

const StyledButton = styled(Button)`
  display: flex;
  font-size: 14px;
  position: absolute;
  right: -1.4rem;
  width: 5rem;
`;

const RemoveButton = styled(StyledButton)`
  width: 6rem;
`;

function CustomerPromoCode({
  callback,
  customerUserId,
  disabled,
  error,
  onChangeCallback,
  remove,
  skipPayments,
  success,
  value,
  vendorBusinessId,
}) {
  const client = useCustomerClient();
  if (skipPayments) { // eslint-disable-line
    return null;
  }
  let errors = null;
  let message = null;
  if (success) {
    message = "Promo code applied successfully!";
  }
  if (error) {
    errors = ["Promo code is not valid."];
  }
  let button = null;
  if (value.length > 2 && !disabled) {
    const url = `${BASE_API_URL}/promo_codes/try_promo_code?name=${value}&customer_user_id=${customerUserId}&vendor_business_id=${vendorBusinessId}`;
    button = (
      <StyledButton
        outlineType="none"
        onClick={async () => {
          client.get(url).then((response) => {
            callback(response);
          }).catch((e) => {
            console.error(e);
          });
        }}
      >
        Apply
      </StyledButton>
    );
  }
  if (success && !disabled) {
    button = (
      <RemoveButton
        textColor={success ? "secondary" : "primary"}
        outlineType="none"
        onClick={remove}
      >
        Remove
      </RemoveButton>
    );
  }
  const onChange = (e) => {
    if (success || disabled) {
      return null;
    }
    return onChangeCallback(e);
  }
  return (
    <Wrapper>
      <Field
        component={TextInput}
        customErrors={errors}
        disabled={disabled}
        input={{
          onChange,
          value,
        }}
        meta={{success}}
        label="Enter coupon/promo code"
        message={message}
        name="promoCodeName"
      />
      {button}
    </Wrapper>
  );
}

CustomerPromoCode.propTypes = {
  disabled: PropTypes.bool,
  skipPayments: PropTypes.bool,
  error: PropTypes.bool.isRequired,
  remove: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
  onChangeCallback: PropTypes.func.isRequired,
  customerUserId: PropTypes.string.isRequired,
  vendorBusinessId: PropTypes.string.isRequired,
};

CustomerPromoCode.defaultProps = {
  disabled: false,
  skipPayments: false,
}

export default CustomerPromoCode;
